import { uiState } from '../../state';
import { getMsgLoader, getMsgLoaderWrapper } from './getMsgLoader';

export function isFinalMessage(msg) {
    return msg.ctx?.final !== false;
}

export function buildMsgIncommingLoader(msg) {
    if (msg.initLoad) return '';
    return !isFinalMessage(msg) ? `<div style="margin-top: 12px;margin-bottom: 4px;">${getMsgLoaderWrapper(getMsgLoader(uiState.textChat.options))}</div>` : '';
}

